class CollectionSplide extends HTMLElement {
	constructor() {
		super();

		this.uniqueClass = `.splide-${this.dataset.id}`;
		this.showArrows = /true/.test(this.dataset.showArrows);
		this.splideType = this.dataset.splideType || 'slide';
		this.classes = {
			isVisible: 'is-visible',
		};

		this.init();
	}

	connectedCallback() {
		this.init();
	}

	init() {
		new Splide(this.uniqueClass, {
			type: this.splideType,
			arrows: true,
			pagination: false,
			perPage: 4,
			gap: '40px',
			breakpoints: {
				1200: {
					perPage: 3,
				},
				768: {
					perPage: 2,
				},
				500: {
					perPage: 2,
				},
				
			},
		}).mount();
	}
}

customElements.define('collection-splide', CollectionSplide);
